export default __webpack_public_path__ + "static/media/quote2.bfdd2460.svg";